import { exportAllActivityHubLogs } from '../../../services/hubs';
import { exportToFile } from '../../../services/export';

export const exportHubActivityLogs = async (search: string) => {
  const result = await exportAllActivityHubLogs(search);
  const fileType = { type: 'text/csv' } as const;
  const blob = new Blob([result.data], fileType);
  exportToFile(blob, fileType, 'HubActivityLogs.csv');
};
